import { render, staticRenderFns } from "./demoUserMultiSelectTable.vue?vue&type=template&id=4b8bb102&scoped=true&"
import script from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"
export * from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8bb102",
  null
  
)

export default component.exports